import { Center, Text } from "@chakra-ui/react";
import { Error } from "../../components";

function NotFound() {
  return (
    <>
      <Center bgImage="/images/cristian-palmer-XexawgzYOBc-unsplash.webp" bgSize="cover" bgPos="bottom">
        <Error color="white" textTransform="uppercase" letterSpacing="2px" fontSize={["md", "x-large", "xxx-large"]}>The requested page was not found</Error>
      </Center>
      <Text pos="absolute" fontSize="xs" bottom="2" left="2" color="gray.400">Image &copy; <a href="https://unsplash.com/photos/clear-blue-body-of-water-XexawgzYOBc?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash" target="_blank" rel="noopener noreferrer">Cristian Palmer on Unsplash</a>
      </Text>
    </>
  );
}

export default NotFound;
